import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { errorHandler } from '../utils.saga';
import { GET_JOB_ROLES, GET_HIRING_ROLES } from '../../constants/ActionTypes';
import {
  getAllInterviewsApi,
  getHiringRolesApi,
} from '../../api/Interviews/jobRole.api';
import { showAlert } from '../../actions/alert.action';
import { IPayload } from '../../types/Interviews/jobRoles.types';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import { EAlertType } from '../../types/alert.types';

/**
 * Get Job Roles
 * @param {IPayload} data:IPayload
 * @returns {void}
 */
function* getJobRoles(data: IPayload) {
  try {
    yield put({
      type: `SHOW_LOADER`,
      payload: {
        show: true,
      },
    });
    const getJobRolesResp: AxiosResponse = yield call(() =>
      getAllInterviewsApi(data.payload)
    );
    if (
      getJobRolesResp &&
      getJobRolesResp.status === HTTP_STATUS_CODES.OK &&
      getJobRolesResp.data
    ) {
      yield put({
        type: `${GET_JOB_ROLES}_SUCCESS`,
        payload: getJobRolesResp.data,
      });
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: EAlertType.ERROR,
        })
      );
  } finally {
    yield put({
      type: `HIDE_LOADER`,
    });
  }
}

/**
 * Get Hiring Roles
 * @returns {void}
 */
function* getRoles() {
  try {
    const getRolesResp: AxiosResponse = yield call(() => getHiringRolesApi());
    if (
      getRolesResp &&
      getRolesResp.status === HTTP_STATUS_CODES.OK &&
      getRolesResp.data
    ) {
      const results = getRolesResp.data.results ?? [];
      const sorted = [...results].sort((a, b) => {
        if (a.slug === 'others') return 1;
        if (b.slug === 'others') return -1;
        if (a.company_slug && !b.company_slug) return -1;
        if (!a.company_slug && b.company_slug) return 1;
        return 0;
      });
      yield put({
        type: `${GET_HIRING_ROLES}_SUCCESS`,
        payload: { ...getRolesResp.data, results: sorted },
      });
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: EAlertType.ERROR,
        })
      );
  }
}

/**
 * Load Job Roles
 * @returns {void}
 */
export default function* loadJobRoles() {
  yield takeLatest(GET_JOB_ROLES, getJobRoles);
  yield takeLatest(GET_HIRING_ROLES, getRoles);
}
